import React from 'react';
import ReactDOM from 'react-dom';
import Skeleton from 'react-loading-skeleton';
import injectService from '@PROJECT_ROOT/assets/responsive-frontend/js/services/injectService';
import { reportError } from '@PROJECT_ROOT/assets/responsive-frontend/js/services/reportService';

export default class BreadCrumbs extends React.Component {
    constructor(props) {
        super(props);
        // Ako se mijenja vrijednost ovog ID-a, potrebno ga je promijeniti i u src\Adriatic\Bundle\ResponsiveFrontendBundle\Resources\views\Shared\layout\head.html.twig unutar script id-a "breadcrumbsStructuredData"
        this.idForScriptStructuredData = 'breadcrumbs-structured-data';
        this.state = {
            portalRoot: null,
        };
        this.renderBreadcrumbsInnerContent = this.renderBreadcrumbsInnerContent.bind(this);
    }

    componentDidMount() {
        const portalRoot = document.getElementById('breadcrumbsReact');
        this.setState({ portalRoot }, () => {
            if (portalRoot) {
                const skeletonSpan = document.getElementById('breadcrumbsStaticSkeleton');
                if (skeletonSpan && portalRoot.contains(skeletonSpan)) {
                    try {
                        portalRoot.removeChild(skeletonSpan);
                    } catch (error) {
                        reportError(new Error('Greška prilikom uklanjanja "breadcrumbsStaticSkeleton" : ', error));
                    }
                }
            }
        });
    }

    componentDidUpdate(prevProps) {
        const { breadcrumbsStructuredData } = this.props;
        if (prevProps.breadcrumbsStructuredData !== breadcrumbsStructuredData) {
            injectService.injectStructuredData(breadcrumbsStructuredData, this.idForScriptStructuredData);
        }
    }

    renderBreadcrumbsInnerContent() {
        const { breadcrumbs, isLoading } = this.props;

        return (
            <div className="breadcrumbsContentInner">
                {isLoading ? (
                    <Skeleton className="breadcrumbsContent__staticSkeleton" />
                ) : (
                    <>
                        {breadcrumbs && (
                            <ol className="breadcrumbs">
                                {breadcrumbs.map((breadcrumb, index) => (
                                    <React.Fragment key={index}>
                                        {breadcrumb.url ? (
                                            <li>
                                                <a href={breadcrumb.url}>
                                                    <span>{breadcrumb.title}</span>
                                                </a>
                                            </li>
                                        ) : (
                                            <li className="breadcrumbs__item--no-url">{breadcrumb.title}</li>
                                        )}
                                    </React.Fragment>
                                ))}
                            </ol>
                        )}
                    </>
                )}
            </div>
        );
    }

    render() {
        const { portalRoot } = this.state;
        return portalRoot && ReactDOM.createPortal(this.renderBreadcrumbsInnerContent(), portalRoot);
    }
}
